module.exports = __webpack_public_path__ + "static/media/building.993ec880.svg";